import React, { MouseEventHandler } from 'react';

import { YesNoBtnRow } from '@infoods/lifebase-ui';
import classes from './ButtonsRow.module.scss';

type ButtonsRowProps = {
  onNext?: MouseEventHandler<HTMLButtonElement>;
  formId?: string;
  yesDisabled?: boolean;
};

const ButtonsRow = ({ onNext, formId, yesDisabled }: ButtonsRowProps) => {
  return (
    <YesNoBtnRow
      yesText="Next"
      className={classes.buttonRow}
      yesHandler={onNext}
      yesDisabled={yesDisabled}
      formId={formId}
    />
  );
};

export { ButtonsRow };
